import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import VideoSettings from '@mui/icons-material/VideoSettings';
import ShowVideo from './ShowVideo';
import ShowVideoEx from './ShowVideoEx';
import DeleteVideo from './DeleteVideo';


import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Moment from 'react-moment';
import moment from 'moment';
import DatePicker from '@mui/lab/DatePicker';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import DisplayMoreRecordInfo from './DisplayMoreRecordInfo';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';




import Cookies from 'universal-cookie';

import { CSVLink } from "react-csv";

import Loading  from '../Loading';
import LoadingDL  from '../LoadingDL';

const cookies = new Cookies();




  class CustomerListResults extends Component {

    constructor(props) {
      super(props);
  
      this.state = {
        records: [],
        limit: 10,
        page: 0,
        count: 0,
        sortmode: "desc",
        sortmodelevel: "desc",
        sortmodedate: "desc",
        sort: "timeRecorded",
        datefrom: null,
        dateto: null,
        searchstring: this.props.hostmail,
        showvideo: false,
        showvideoex: false,
        videoid: null,
        loaddata: true,
        loaderror: false,
        loadcsv: true,
        csvdata: [],
        exportcsv: false
      }


      this.closeVideoPage = this.closeVideoPage.bind(this)
      this.closeVideoPageex = this.closeVideoPageex.bind(this)
      this.handleLimitChange = this.handleLimitChange.bind(this);
      this.handlePageChange = this.handlePageChange.bind(this);
      this.closeexportcsvdata = this.closeexportcsvdata.bind(this);
      this.getexportcsvdata = this.getexportcsvdata.bind(this);
      this.handlefilterdateafterdelete = this.handlefilterdateafterdelete.bind(this)
    }

    componentDidMount() {
      //console.log(this.props)

      
      let newdateto
      let newdatefrom
      let datefrom =  new Date()
      datefrom = moment(datefrom)
    
      datefrom.set({hour:0,minute:0,second:0,millisecond:0})
      
      if (this.props.hostmail === "undefined"){
      datefrom.subtract(30, 'd').format()
      } else {
       
       newdateto = moment(this.props.direktdate)
       newdateto.add(10, 'm').format()
       newdatefrom = moment(this.props.direktdate)
       newdatefrom.add(5, 'm').format()
       
       
       if (this.props.direktdate === "nodate"){
        newdateto="";
        newdatefrom="";
       }
        

       this.setState ({
        datefrom: newdatefrom._d,
        dateto: newdateto._d
      })
        
     

      }
      
      
      let dateto =  new Date()
      dateto = moment(dateto)
      dateto.set({hour:23,minute:59,second:59,millisecond:0}).format()


    if (this.props.direktdate === "undefined"){
      this.setState ({
        datefrom: datefrom._d,
        dateto: dateto._d
      })
    }

      //console.log(this.props.direktdate)
      //console.log(newdateto)

      if (this.props.directvidid === "undefined"){
      this.getrecords(this.props.apitoken, 0 , this.state.limit , this.state.sortmode, this.state.sort, this.state.searchstring, datefrom._d, dateto._d);
      } else {
      if (newdatefrom._i === "undefined"){
        newdatefrom = "";
        newdateto = "";
      }
      
      this.getrecords(this.props.apitoken, 0 , this.state.limit , this.state.sortmode, this.state.sort, this.props.hostmail, newdatefrom, newdateto );
      cookies.remove('hostmail')
      cookies.remove('direktdate')
      }
      this.setState ({
        loaddata: false
      })
    }
    

    resetfilter = () => {
      this.setState ({
        limit: 10,
        page: 0,
        count: 0,
        sortmode: "desc",
        sortmodelevel: "desc",
        sort: "timeRecorded",
        sortmodedate: "desc",
        datefrom: null,
        dateto: null,
        searchstring: ""
      })
      this.getrecords(this.props.apitoken, 0 , this.state.limit , this.state.sortmode, this.state.sort);
    }

 
     handleLimitChange = (event) => {
      this.setState ({
        limit: event.target.value,
        loaddata: true
      })


      this.getrecords(this.props.apitoken, this.state.page , event.target.value, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
    };
  
    handlePageChange = (event, newPage) => {  
      this.setState ({
        page: newPage,
        loaddata: true    
    })

    this.getrecords(this.props.apitoken, newPage + 1, this.state.limit, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);  
    };  
    
    closeVideoPage = (event) => {
      this.setState ({
        showvideo: false,
        videoid: null
    })
  }

  closeVideoPageex = (event) => {
    this.setState ({
      showvideoex: false,
      videoid: null
  })
}


  

  // Sort Funktionen
  sortdescmessage = (event) => {
    this.setState ({
      sortmode: "desc",
      sort: "topic",
      loaddata: true    
  })
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
  }

  sortascmessage = (event) => {
    this.setState ({
      sortmode: "asc",
      sort: "topic",
      loaddata: true    
  })
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmode, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
  }
  
  sortdesclevel = (event) => {
    this.setState ({
      sortmodelevel: "desc",
      sort: "level",
      loaddata: true    
  })
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
  }

  sortasclevel = (event) => {
    this.setState ({
      sortmodelevel: "asc",
      sort: "level",
      loaddata: true    
  })
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
  }

  sortdescdate = (event) => {
    this.setState ({
      sortmodedate: "desc",
      sort: "timeRecorded",
      loaddata: true    
  })
  let helpsortmodedate = "desc"
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, helpsortmodedate, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
  }

  sortascdate = (event) => {
    this.setState ({
      sortmodedate: "asc",
      sort: "timeRecorded",
      loaddata: true    
  })
  let helpsortmodedate = "asc"
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, helpsortmodedate, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto); 
  }


  fullsearch = (event) => {
    event.preventDefault()
    this.setState ({
      searchstring: event.target.searchstring.value,
      page: 0,
      loaddata: true
  })
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, event.target.searchstring.value, this.state.datefrom, this.state.dateto); 
  }


  handledatefrom(datefrom){
    
    if (datefrom !== null){
      //datefrom.add(2, 'hours').utc().format()
      datefrom.set({hour:0,minute:0,second:0,millisecond:0})
      

      this.setState({
        datefrom: datefrom._d
      }); 
    } else {
      this.setState({
        datefrom: null
      }); 
    }
  }

  handledateto(dateto){
   
    if (dateto !== null){
     
     // dateto.add(2, 'hours').utc().format()
      dateto.set({hour:23,minute:59,second:59,millisecond:0})
      //dateto = dateto.toISOString()
      
    this.setState({
      dateto: dateto._d
    });
    } else {
    this.setState({
      dateto: null
    }); 
  }
    
}

handlefilterdate= (event) =>{
  event.preventDefault()
  this.setState({
    loaddata: true
    
  });
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);
}

handlefilterdateafterdelete = () =>{
  this.setState({
    loaddata: true,
    videoid: null,
    showvideo: false
  });
  this.getrecords(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);
}



getexportcsvdata = (event) =>{
  this.setState({
    exportcsv: true
  });
  this.getrecordscsv(this.props.apitoken, this.state.page , this.state.limit, this.state.sortmodelevel, this.state.sort, this.state.searchstring, this.state.datefrom, this.state.dateto);
}

closeexportcsvdata = (event) =>{
  this.setState({
    exportcsv: false,
    csvdata: [],
    loadcsv: true,
  });
}


  getrecords (token,page,limit,sortmode,sort,searchstring,datefrom,dateto)  {
      let apiurl = window.apiurl

      if (searchstring === undefined){
        searchstring = "";
      }

      if (datefrom === null || datefrom === undefined || datefrom === ""){
        datefrom = "";
      } else {
        datefrom = encodeURIComponent(datefrom.toISOString())
      }
      

      if (dateto === null || dateto === undefined || dateto === ""){
        dateto = "";
      } else {
        dateto = encodeURIComponent(dateto.toISOString())
      }

      fetch("https://"+apiurl+"/api/Recording/?pageNumber="+page+"&pageSize="+limit+"&sortmode="+sortmode+"&sort="+sort+"&from="+datefrom+"&to="+dateto+"&query="+searchstring+"", {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          },
        })
          .then(res => res.json())
          .then(json => {
            //console.log("---------------")
            //console.log(json)
            //console.log("---------------")
            this.setState ({
              records: json.data,
              count: json.totalRecords,
              loaddata: false
          })  
          })
          .catch(error => {
            console.log(error.status);
            this.setState ({
              loaddata: false,
              loaderror: true
          })  
        });               
        }

    getrecordscsv (token,page,limit,sortmode,sort,searchstring,datefrom,dateto)  {
          let apiurl = window.apiurl
          
    
          if (searchstring === undefined){
            searchstring = "";
          }
         
          if (datefrom === null || datefrom === undefined){
            datefrom = "";
          } else {
            datefrom = encodeURIComponent(datefrom.toISOString())
          }
          
    
          if (dateto === null || dateto === undefined){
            dateto = "";
          } else {
            dateto = encodeURIComponent(dateto.toISOString())
          }
    
    
    
    
    
          fetch("https://"+apiurl+"/api/Recording?pageNumber="+page+"&PageSize="+limit+"&Sort="+sort+"&SortMode="+sortmode+"&From="+datefrom+"&To="+dateto+"&export=csv&query="+searchstring +"", {
              method: 'GET',
              headers: {
                'Accept': 'text/csv',
                'Content-Type': 'text/csv',
                'Authorization': 'Bearer ' + token,
              },
            })
              .then(res => res.text())
              .then(text => {
                //console.log(text)
                this.setState ({
                  csvdata: text,
                  loadcsv: false
              })
                
               
              })
              .catch(error => {
                console.log(error.status);
                this.setState ({
                  loaddata: false,
                  loaderror: true,
                  
              })  
            });               
            }


    showvideo(id) {
      this.setState ({
        videoid: id,  
        showvideo: true
      })  
     } 

     showvideoex(id) {
      this.setState ({
        videoid: id,  
        showvideoex: true
      })  
     }
     
     downloadvideo(id) {
      //let url = window.apiurl +"https://webextank-api.webquake.com/api/Recording/"
      let url = "https://" + window.apiurl + "/api/Recording/"
      let token = "/?d=0&t=" + encodeURIComponent(this.props.apitoken)
      let source = url + id + token;
      window.open(source, '_blank', 'noopener,noreferrer')
     } 
     



    handleChange(e) {
      //console.log (e.target.name + "|" + e.target.value)
      this.setState({
        [e.target.name]: e.target.value
      })
    }



render () {
     //console.log(this.props.userrights.eraser) 
     // console.log(this.state.dateto) 
     let outdatefrom = moment(this.state.datefrom).format("DD-MM-YYYY")
     let outdateto = moment(this.state.dateto).format("DD-MM-YYYY")
     let filenname ="Recordings_"+outdatefrom+"-"+outdateto+".csv"
 
  
    if (this.state.loaddata) {
      return (
        <Loading />
      )
    }
    
    if (this.state.loaderror) {
      return (
        <Alert severity="error"><strong>{intl.get('LIST_DATA_ERROR')}</strong><br />{intl.get('LIST_DATA_ERROR_DESC')}</Alert>
      )
    }
      


  if (this.state.showvideo) {
      return (
        <Box  sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed #0272b3', borderRadius: 2, bgcolor: '#0272b3' }}>
         
          <ShowVideo videoid={this.state.videoid} closeVideoPage={this.closeVideoPage} token={this.props.apitoken}/>
          {this.props.userrights.eraser === 1 &&
           <Fragment>
            <hr />
            <DeleteVideo videoid={this.state.videoid} token={this.props.apitoken} handlefilterdateafterdelete={this.handlefilterdateafterdelete}/>
            </Fragment>
          }
        </Box>
      )}

  if (this.state.showvideoex) {
        return (
          <Box  sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed #0272b3', borderRadius: 2, bgcolor: '#0272b3' }}>
           
            <ShowVideoEx videoid={this.state.videoid} closeVideoPageex={this.closeVideoPageex} token={this.props.apitoken}/>
            {this.props.userrights.eraser === 1 &&
             <Fragment>
              <hr />
              <DeleteVideo videoid={this.state.videoid} token={this.props.apitoken} handlefilterdateafterdelete={this.handlefilterdateafterdelete}/>
              </Fragment>
            }
          </Box>
        )}

  return (
    <Fragment>
      
    <Box component="form" onSubmit={this.fullsearch} sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: '#edf3f7' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={10} md={10} lg={4} xl={6}>
        <FormControl variant="standard" fullWidth sx={{ m: 1 }}>
          <InputLabel htmlFor="input-with-icon-adornment">
          {intl.get('LIST_SEARCH_LABEL')}
          </InputLabel>
          <Input
            id="input-with-icon-adornment"
            name="searchstring"
            value={this.state.searchstring}
            onChange={(e) => this.handleChange(e)}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </FormControl>
        </Grid>
        <Grid item xs={12} sm={2} md={1} lg={1} xl={1}>
        <Button
              type="submit"
              variant="contained"
              sx={{ mt: 1, mb: 1 }}
            >
              {intl.get('LIST_SEARCH_BUTTON')}
            </Button>
            </Grid> 
            <Grid item xs={12} sm={5} md={5} lg={3} xl={2}>
          <DatePicker
          label={intl.get('LIST_DATE_FROM')}
          inputFormat='DD.MM.YYYY'
          onChange={val => {
            this.handledatefrom(val);
          }} 
          value={this.state.datefrom}
          variant="standard"
          color="secondary"
          renderInput={(params) => <TextField {...params} />}
        />
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={3} xl={2}>
        <DatePicker
          label={intl.get('LIST_DATE_TO')}
          inputFormat='DD.MM.YYYY'
          onChange={val => {
            this.handledateto(val);
          }} 
          value={this.state.dateto}
          variant="standard"
          color="secondary"
          renderInput={(params) => <TextField {...params} />}
        />
        </Grid>
        <Grid item xs={1} sm={5} md={1} lg={1} xl={1}>
        <Button onClick={this.handlefilterdate}
              variant="contained"
              sx={{ mt: 1, mb: 1 }}
            >
              {intl.get('LIST_DATE_FILTER')}
            </Button>
            </Grid>
        <Grid item xs={1}>    
            <Button onClick={()=>this.resetfilter()}
              variant="contained"
              sx={{ mt: 1, mb: 1 }}
            >
              Reset 
      </Button>




            </Grid>
            <Grid item xs={6} sm={5} md={6} lg={6} xl={1}>
        {this.state.exportcsv &&    
        <Button onClick={this.closeexportcsvdata}
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
          >
            <span>{intl.get('CSV_LIST_BUTTON')}</span>
        </Button>
        }

        {!this.state.exportcsv &&    
        <Button onClick={this.getexportcsvdata}
            variant="contained"
            sx={{ mt: 1, mb: 1 }}
          >
            <span>{intl.get('CSV_DLS_BUTTON')}</span>
        </Button>
        }
        
        
        </Grid>
        </Grid>
        </Box>

        {this.state.records.length === 0 &&
              <Alert severity="error"><strong>{intl.get('LIST_DATA_NORESULT')}</strong><br />{intl.get('LIST_DATA_NORESULTINFO')}</Alert>
            }
        
        {!this.state.exportcsv &&
         <Fragment>
        <Box  sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: 'rgb(248, 248, 248)' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{width:'60%'}}>
                {intl.get('LIST_REC_INHALT')} {this.state.sortmode === "asc" &&
                    <ArrowDropDownIcon onClick={this.sortdescmessage} />
                  } 
                  {this.state.sortmode === "desc" &&
                    <ArrowDropUpIcon onClick={this.sortascmessage} />
                  }
                </TableCell>
                <TableCell style={{width:'10%'}}>
                {intl.get('LIST_REC_DAUER')}
                </TableCell>
                <TableCell style={{width:'20%'}}>
                {intl.get('LIST_REC_AUFGEZEICHNET')}
                {this.state.sortmodedate === "asc" &&
                    <ArrowDropUpIcon onClick={this.sortdescdate} />
                  } 
                  {this.state.sortmodedate === "desc" &&
                    <ArrowDropDownIcon onClick={this.sortascdate} />
                  } 
                </TableCell>
               
                <TableCell style={{width:'10%'}}>
                {intl.get('LIST_REC_VIEW')}
                
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

   
              
              {this.state.records.map((record) => (
                <TableRow
                  hover
                  key={record.id}
                >
                  <TableCell>
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        <strong>{record.title}</strong> | <em>{record.hostDisplayName}</em><br />
                        <p>{record.topic}</p>
                        <DisplayMoreRecordInfo recordinfo={record} token={this.props.apitoken}/>
                        


                      </Typography>
                    
                  </TableCell>
                  <TableCell>
                    
                  {record.durationSeconds} sec
                    
                  </TableCell>
                  <TableCell>
                  <Moment format="DD.MM.YYYY">{record.timeRecorded}</Moment>
                  </TableCell>
                 
                  <TableCell>
                 
                  {record.status === 1 &&
                   <Fragment>
                    <VideoSettings fontSize="large" onClick={()=>this.showvideoex(record.id)}/><span className="maright"></span>
                    <OndemandVideoIcon fontSize="large" onClick={()=>this.showvideo(record.id)}/><span className="maright"></span>
                    <CloudDownloadIcon fontSize="large" onClick={()=>this.downloadvideo(record.id)}/>
                  </Fragment> 
                  }

                  {record.status !== 1 &&
                   <Fragment>
                    <HourglassEmptyIcon fontSize="large" />
                  </Fragment> 
                  }

             
                  
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </Box>
      <Box sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: '#edf3f7' }}>
      <TablePagination
        component="div"
        count={this.state.count}
        onPageChange={this.handlePageChange}
        onRowsPerPageChange={this.handleLimitChange}
        page={this.state.page}
        rowsPerPage={this.state.limit}
        rowsPerPageOptions={[5, 10, 25]}
      />
      </Box>
      </Fragment>
      }

{this.state.exportcsv &&
    <Fragment>
      <Box  sx={{ mt: 4, mb: 4, p: 2, border: '1px dashed grey', borderRadius: 2, bgcolor: 'rgb(248, 248, 248)' }}>
      <Grid container spacing={2} >
          <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
      <Alert severity="info">
        <AlertTitle>{intl.get('CSV_HEAD_INFO')}</AlertTitle>
        {intl.get('CSV_CONT_INFO')}  
        </Alert>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5} align="center">
        {this.state.csvdata.length === 0 && this.state.loadcsv &&
             <LoadingDL />
        }

        {this.state.csvdata.length !== 0 && !this.state.loadcsv &&
        <CSVLink
          data={this.state.csvdata}
          filename={filenname}
          className="dashbuttondl"
          target="_blank"
        >
         {intl.get('CSV_DL_BUTTON')}
      </CSVLink>
      }
        </Grid>
       </Grid> 
    </Box>
    </Fragment>

    }

     </Fragment>
  );
};
  }



export default CustomerListResults;
